// css =>
import "../../BaseStructure.css";
import Styled from "./menuBar.module.css";

// icons =>
import BagIcon from "../../Assets/Icons/bag.png";
import HomeIcon from "../../Assets/Icons/home.png";
import ProfileIcon from "../../Assets/Icons/profile.png";
import ShoppingCardIcon from "../../Assets/Icons/shopping-card.png";

// react =>
import { useNavigate, useLocation } from "react-router-dom";

function MenuBar() {

    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className={`row ${ Styled.MenuBarSection }`}>

            <div className={`col-5 ${ Styled.MenuBar } `}>
                <div
                    className={`col-3 ${ location.pathname === "/" ? Styled.active : "" } `}
                    onClick={() => {
                        navigate("/");
                    }}>
                    <img src={ HomeIcon } alt="Home" />
                </div>
                <div
                    className={`col-3 ${ location.pathname === "/shopping-card" ? Styled.active : "" } `}
                    onClick={() => {
                        navigate("/shopping-card");
                    }}>
                    <img src={ ShoppingCardIcon } alt="shopping card" />
                </div>
                <div
                    className={`col-3 ${ 
                        location.pathname === "/show-products" ||
                        location.pathname === "/product-info" ?
                        Styled.active : "" } `}
                    onClick={() => {
                        navigate("/show-products");
                    }}>
                    <img src={ BagIcon } alt="products" />
                </div>
                <div
                    className={`col-3 ${ 
                        location.pathname === "/edit-profile" ||
                        location.pathname === "/order-show" ||
                        location.pathname === "/order-history" ||
                        location.pathname === "/favorites" ?
                        Styled.active : "" } `}
                    onClick={() => {
                        navigate("/edit-profile");
                    }}>
                    <img src={ ProfileIcon } alt="profile" />
                </div>
            </div>
        </div>
    );
}

export default MenuBar;
